import { ISeasonTicket } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/dto/ResponseDto';

import { IAction } from '~/src/store';
import { EWholesaleCheaperTypes } from '~/src/store/actionTypes/wholesaleCheaper';

export const setLoadingStatus = (status: boolean):
    IAction<typeof EWholesaleCheaperTypes.SET_LOADING_STATUS, boolean> => ({
        type: EWholesaleCheaperTypes.SET_LOADING_STATUS,
        payload: status,
    });

export const setWholesaleCheaperData = (payload: ISeasonTicket | undefined):
    IAction<typeof EWholesaleCheaperTypes.SET_WHOLESALE_CHEAPER_DATA, ISeasonTicket | undefined> => ({
        type: EWholesaleCheaperTypes.SET_WHOLESALE_CHEAPER_DATA,
        payload,
    });
